/**
 * @author: lv.chen3
 * @desc: FileNameCard组件
 * @date: 2025/8/11
 */
import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';

import './index.scss';

import ICON_DOC from '@user-center/assets/svgs/files/doc.svg';
import ICON_PPT from '@user-center/assets/svgs/files/ppt.svg';
import ICON_PDF from '@user-center/assets/svgs/files/pdf.svg';
import ICON_UNKNOW_FILE from '@user-center/assets/svgs/files/unknow.svg';

const fileIconMap: IRecord<string> = {
  doc: ICON_DOC,
  docx: ICON_DOC,
  ppt: ICON_PPT,
  pptx: ICON_PPT,
  pdf: ICON_PDF,
};

const getFileFormat = (name: string, format?: string): string => {
  if (!!format) return format;
  if (!name) return '';
  const dotIndex = name.lastIndexOf('.');
  return name.substring(dotIndex + 1);
};

interface IFileNameCardProps extends IBaseProps {
  showDelete?: boolean;
  format?: string;
  name: string;
  onDelete?: () => void;
}

const FileNameCard: React.FC<IFileNameCardProps> = (props) => {
  const { style, className, showDelete = false, format: formatProps, name, onDelete } = props;

  const format = getFileFormat(name, formatProps);

  return (
    <div style={style} className={classnames('dbu-file-name-card', className)}>
      <img className="dbu-file-name-card__icon" src={fileIconMap[format] || ICON_UNKNOW_FILE} alt="" />
      <span className="dbu-file-name-card__name">{name}</span>
      {showDelete && (
        <SvgIcon
          className="dbu-file-name-card__delete-icon"
          type="clonse"
          onClick={(e) => {
            e?.stopPropagation();
            onDelete?.();
          }}
        />
      )}
    </div>
  );
};

export default FileNameCard;
